export enum UserRole {
  User = 0,
  WidgetEditor = 1,
  TenantAdmin = 2,
  GroupAdmin = 3,
  SuperAdmin = 4,
}
